import { z } from 'zod'
import { SchemaElenchi } from '@praticheenergia/domain'
import { supabase } from '../lib/supabase'

export type Elenchi = z.infer<typeof SchemaElenchi>

/** N (energia venduta ad altri operatori), T (provenienza) e perdite stanno in
 * dichiarazione.elenchi; il motore li legge da li'. Si valida prima di
 * scrivere: il worker rifiuterebbe comunque un JSON fuori schema. */
export async function salvaElenchi(dichiarazioneId: number, elenchi: Elenchi): Promise<void> {
  const validi = SchemaElenchi.parse(elenchi)
  const { error } = await supabase.from('dichiarazione').update({ elenchi: validi }).eq('id', dichiarazioneId)
  if (error) throw new Error(error.message)
}
